import { Text } from "@nike/eds";

export const TableMessage = ({msg}: {msg: string}) => (
    <div className='noDataText'>
        <Text font="title-4" as="h4" className="eds-spacing--mt-56 eds-spacing--mb-56" style={{ justifyContent: "center", textAlign: "center" }}>{msg}</Text>
    </div>
);